<div class="astrea-home-banner">
    <button class="arrow left" (click)="previousBanner()">&#9664;</button>

    <a [routerLink]="currentBanner.url" [title]="currentBanner.title">
        <img [src]="currentImageSrc" [class.fade]="isFading" [alt]="currentBanner.title" />
    </a>

    <button class="arrow right" (click)="nextBanner()">&#9654;</button>
</div>
